import * as yup from 'yup';
import moment from "moment";

export const ProfileDetailsSchema = yup.object().shape({
    Country: yup.string().required(),
    PhoneNumber: yup.string().required(),
    BirthDate: yup.date().max(moment().subtract(18, "years")).required(),
    // IdType: yup.string().email().required(),
    // IdNumber: yup.string()
})

export const UserDetailsSchema = yup.object().shape({
    FirstName: yup.string().required(),
    LastName: yup.string().required(),
    Email: yup.string().email().required(),
    Password: yup.string().min(6).max(30).required(),
    PasswordConfirmation: yup.string().oneOf([yup.ref('Password')], "Passwords must match!").required() 
});